// Teams-style search filters typed into the search box: from:priya  in:launch  has:file  has:link  has:mention
// before:2026-10-01  after:2026-09-01. The rest of the text is what the server searches for; the filters narrow its hits here.

export interface SearchFilters {
    from?: string;
    in?: string;
    has?: "file" | "link" | "mention" | "poll";
    before?: Date;
    after?: Date;
}

export interface ParsedSearch {
    text: string;
    filters: SearchFilters;
    /** The chips to show, in the order typed. */
    chips: string[];
}

const TOKEN = /(^|\s)(from|in|has|before|after):("[^"]+"|\S+)/gi;

export function parseSearch(raw: string): ParsedSearch {
    const filters: SearchFilters = {};
    const chips: string[] = [];
    const text = raw.replace(TOKEN, (whole, lead: string, key: string, value: string) => {
        const v = value.replace(/^"|"$/g, "");
        const k = key.toLowerCase();
        if (k === "from") filters.from = v.toLowerCase();
        else if (k === "in") filters.in = v.toLowerCase();
        else if (k === "has") {
            const h = v.toLowerCase();
            if (h === "file" || h === "attachment" || h === "files") filters.has = "file";
            else if (h === "link" || h === "links") filters.has = "link";
            else if (h === "mention" || h === "mentions") filters.has = "mention";
            else if (h === "poll") filters.has = "poll";
            else return whole;
        } else {
            const d = new Date(`${v}T00:00:00`);
            if (Number.isNaN(d.getTime())) return whole;
            if (k === "before") filters.before = d;
            else filters.after = d;
        }
        chips.push(`${k}:${v}`);
        return lead;
    }).replace(/\s+/g, " ").trim();
    return { text, filters, chips };
}

/** Whether a hit passes the filters. `containerName` is the chat or channel the hit sits in, when known. */
export function matchesFilters(hit: { author: string; bodyHtml: string; sentAt: string }, f: SearchFilters, containerName?: string): boolean {
    if (f.from && !hit.author.toLowerCase().includes(f.from)) return false;
    if (f.in && !(containerName ?? "").toLowerCase().includes(f.in)) return false;
    const at = new Date(hit.sentAt).getTime();
    if (f.before && !(at < f.before.getTime())) return false;
    if (f.after && !(at >= f.after.getTime() + 0)) return false;
    if (f.has === "file" && !/data-fg-file|fg-file/i.test(hit.bodyHtml)) return false;
    if (f.has === "link" && !/<a\s[^>]*href=/i.test(hit.bodyHtml)) return false;
    if (f.has === "mention" && !/data-fg-mention/i.test(hit.bodyHtml)) return false;
    if (f.has === "poll" && !/data-fg-poll/i.test(hit.bodyHtml)) return false;
    return true;
}
